export default {
  about: {
    hero: {
      eyebrow: 'من نحن',
      title: 'شخصي. احترافي. دقيق.',
      lead: 'تمثل {{name}} مراقبة بالفيديو مخططة بشكل فردي وعناية شخصية من مصدر واحد.',
    },
    story: {
      quote: '«بدلًا من بيع باقات جاهزة، يُنظر إلى كل مبنى وفق حاجته الفعلية – من مناطق الصورة المطلوبة إلى نقاط التركيب والتسجيل وإعداد التطبيق.»',
      p1: 'يدير {{name}} {{owner}} – جهة اتصالك الشخصية من الاستشارة الأولى إلى العناية المستمرة. يعمل في تقنية الأمان منذ أكثر من 20 عامًا ونفّذ مئات المشاريع للأفراد والشركات.',
      p2: 'تغطي الخبرة الطويلة تخطيط وتركيب أنظمة الكاميرات في المنازل والعمارات والمتاجر والمكاتب والعيادات والمطاعم والمستودعات والورش ومناطق الإنتاج. يُنظر إلى كل مشروع بشكل فردي.',
      p3: 'حسب متطلبات المشروع، تعتمد {{name}} من بين أمور أخرى على أنظمة مجرّبة من Hikvision وSafire. ويمكن أيضًا تخطيط حلول من مصنّعين آخرين.',
      p4: 'لا ترى {{name}} نفسها مجرد بائع، بل شريكًا طويل الأمد. بعد التركيب يبقى التواصل الشخصي قائمًا.',
    },
    owner: {
      subtitle: 'تقنية أمان من هاينبورغ',
      photoPlaceholder: 'صورة المالك قريبًا',
      role: 'المالك وجهة الاتصال',
    },
    milestonesTitle: 'خبرة تُحدث فرقًا',
    milestones: {
      '0': { year: 'أكثر من 20 عامًا', desc: 'خبرة في تخطيط وتركيب أنظمة الكاميرات للأفراد والشركات في منطقة راين-ماين.' },
      '1': { year: 'مئات المشاريع المنجزة', desc: 'من المنازل إلى المتاجر والمنشآت الكبيرة: كل مشروع مخطط بشكل فردي.' },
      '2': { year: 'مستقل عن المصنّعين', desc: 'نختار التقنية المناسبة لمتطلباتك، حسب المشروع، من مصنّعين معروفين.' },
    },
    valuesTitle: 'ما يميّز {{name}}',
    values: {
      '0': { title: 'تخطيط فردي', desc: 'لا باقات جاهزة. يُنظر إلى كل مبنى وفق حاجته الفعلية.' },
      '1': { title: 'تنفيذ احترافي', desc: 'تركيب نظيف وتوجيه صحيح وتمديدات احترافية.' },
      '2': { title: 'ربط رقمي', desc: 'تطبيق ووصول عن بُعد وإشعارات – مُعدّة ومشروحة.' },
      '3': { title: 'عناية شخصية', desc: 'جهة اتصال واحدة. موثوقة. حتى بعد التركيب.' },
    },
    cta: {
      title: 'تعرّف علينا',
      lead: 'محادثة أولى غير ملزمة تُظهر سريعًا إن كنا متوافقين. نتطلع إلى معرفة مشروعك.',
      primary: 'احجز موعدًا',
      secondary: 'الأسئلة الشائعة',
    },
  },
};